<template>
  <div class="detail" id="detail">
    <div class="de-box fl">
      <div class="mian-title">
        {{ newInfo.article_title }}
      </div>
      <div class="main-date">
        <span>{{ newInfo.publish_time }}　</span>
        <span>点击次数:{{ newInfo.visit_no }}</span>
      </div>
      <div id="mainBox" class="main-box" v-if="newInfo && newInfo.dynamic_data && newInfo.dynamic_data.content"
        v-html="newInfo.dynamic_data.content">

      </div>
      <div v-if="newInfo && newInfo.dynamic_data && newInfo.dynamic_data.attachment" >
        附件下载：<span @click="download(newInfo.dynamic_data.attachment)" class="file-download">{{(newInfo.dynamic_data.attachment.split("?")[1]).split("&fileName=")[1]}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    articleId: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      newInfo: {}
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    download(val) {
      let params = val.split("?")[1]
      let fileName = params.split("&fileName=")[1]
      
      this.$common.noLoginCallUrl4GET(
        val,
        function (data) {
          let content = data;
          let blob = new Blob([content]); // 构造一个blob对象来处理数据
          let link = document.createElement("a"); // 创建a标签
          console.log(fileName)
          link.download = fileName; // a标签添加属性
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click(); // 执行下载
        },
        function (res) { }
      );
    },
    getInfo() {
      let self = this
      this.newInfo = {}
      this.$common.noLoginCallUrl('/api/cp-cms/site/info/getInfo', {
        article_id: self.articleId,
      },
        function (res) {
          if (res.code == '000000') {
            self.newInfo = res.data || {}
          } else {
            self.$message.warning(res.msg)
          }
        })
    }
  },
  watch: { // 监听，当路由发生变化的时候执行

  }
};
</script>

<style lang="less" scoped>
.detail {

  .de-box {
    width: 100%;
    box-sizing: border-box;
    padding: 0px 40px 40px;

    .mian-title {
      text-align: center;
      font-size: 22px;
      margin: 10px 0;
    }

    .main-date {
      margin-top: 40px;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
      color: #666;
    }

    .main-box {
      // text-align: center;
      margin-top: 20px;

      img {
        width: 600px;
        margin: 20px auto;
        text-align: center
      }

      p {
        text-align: left;
        text-indent: 2em;
        font-size: 16px;
        line-height: 30px;
        padding: 0 10px;
      }

      table {
        width: 100% !important;
      }
    }

    .box-list {
      width: 800px;
      margin: 20px auto;
      height: 270px;
      box-sizing: border-box;
      padding: 10px;
      cursor: pointer;
      border-bottom: dashed 1px #dedede;

      .box-list-img {
        width: 250px;
        height: 200px;
        margin-right: 20px;

        img {
          width: 250px;
          height: 200px;
        }
      }

      .box-list-font {
        width: 450px;
        height: 200px;

        .title {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 20px;
        }

        .info {
          font-size: 14px;
          color: #666666;
        }
      }
    }
  }

  .file-download{
    font-weight: 600;
    padding: 20px 0;
    cursor:pointer;
  }
}

@media screen and (max-width: 1025px) {

  .de-box {
    padding: 0 0 20px !important;
  }

}
</style>
<style>

#mainBox table {
  width: 100%;
}

#mainBox video {
  width: 100%;
}

#mainBox img {
  width: 100%;
  text-indent: 0;
  margin: 0 auto;
}

#mainBox a {
  overflow-wrap: break-word;
}
</style>